// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"594f135e","453":"184d10ab","732":"c6b0019c","977":"b3e2c81b"}[chunkId] + ".chunk.js";
};